<!-- <section class="content-header" style="padding:5px !important">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-md-6">
                <ol class="breadcrumb ">
                    <li *ngFor="let item of breadCrumbs" [class]="item.className">
                        <a [routerLink]="[item.routerLink]" [class.disabled]="!item.active ? true : null"><i [class]="item.icon"></i> &nbsp;{{item.name}}</a>
                    </li>
                </ol>
            </div>
        </div>
    </div>
</section> -->


<ol class="breadcrumb float-sm-left" style="padding: 0 !important;">
    <li *ngFor="let item of breadCrumbs" [class]="item.className">
        <a [routerLink]="[item.routerLink]" [class.disabled]="!item.active ? true : null"><i [class]="item.icon"></i>
            &nbsp;{{item.name}}</a>
    </li>
</ol>